<template>
  <div>
    <div class="legal-hero">
      <div class="col">
        <div class="legal-eyebrow">Legal</div>
        <h1 class="legal-title">Termos de Uso</h1>
      </div>
    </div>
    <div class="col legal-col">
      <div class="legal-bloco" v-revela>
        <p class="legal-updated">Última atualização: julho de 2026</p>

        <h3 class="legal-h">O serviço</h3>
        <p class="legal-p">{{ EMPRESA.nome }} presta serviços de transporte rodoviário de carga (CNAE {{ EMPRESA.cnaeCodigo }} — {{ EMPRESA.cnae }}) para clientes em {{ EMPRESA.cidade }} e região. A contratação é feita mediante proposta prévia via site ou WhatsApp, com valor e prazo confirmados antes da execução. Cargas enquadradas como produto perigoso só são aceitas com a classificação, a documentação e o veículo exigidos para o produto.</p>

        <h3 class="legal-h">Responsabilidades de {{ EMPRESA.nome }}</h3>
        <p class="legal-p">Executar o serviço no prazo combinado, comunicar o status ao contratante, emitir comprovante e zelar pela qualidade da entrega, conforme as condições declaradas pelo contratante.</p>

        <h3 class="legal-h">Responsabilidades do contratante</h3>
        <p class="legal-p">Declarar corretamente as informações necessárias para a execução do serviço, garantir disponibilidade no horário combinado e informar dados de contato corretos. Solicitações ilícitas ou em desacordo com a declaração não são atendidas.</p>

        <h3 class="legal-h">Cancelamento</h3>
        <p class="legal-p">Serviços podem ser cancelados sem custo até o início da execução. Após iniciada a execução, o valor é devido integralmente.</p>

        <h3 class="legal-h">Foro</h3>
        <p class="legal-p">Fica eleito o foro da comarca de {{ EMPRESA.cidade }} para dirimir eventuais controvérsias.</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { EMPRESA } from '@/config/contato'
</script>

<style src="@/assets/legal.css" scoped></style>
